import { addLocale, useLocale } from 'ttag'

import moment from 'moment'
import 'moment/locale/ar'
//import 'moment/locale/bs'
import 'moment/locale/da'
import 'moment/locale/de'
import 'moment/locale/et'
//import 'moment/locale/en'
import 'moment/locale/es'
import 'moment/locale/fr'
import 'moment/locale/hr'
import 'moment/locale/it'
import 'moment/locale/ja'
import 'moment/locale/lv'
import 'moment/locale/lt'
import 'moment/locale/hu'
import 'moment/locale/nl'
// no
import 'moment/locale/nb'
import 'moment/locale/pl'
import 'moment/locale/pt'
import 'moment/locale/ro'
import 'moment/locale/sq'
import 'moment/locale/sl'
import 'moment/locale/sk'
import 'moment/locale/fi'
import 'moment/locale/sv'
import 'moment/locale/tr'
import 'moment/locale/cs'
import 'moment/locale/el'
import 'moment/locale/bg'
import 'moment/locale/ru'
import 'moment/locale/sr'
import 'moment/locale/uk'
// zh_hans
import 'moment/locale/zh-cn'

import 'moment/locale/id'
import 'moment/locale/th'
import 'moment/locale/vi'

import { Lang } from './services/api.types'
import { Preferences } from '@capacitor/preferences'

export const languages = [
  // English (default)
  { lang: Lang.EN, name: 'English' },

  // Albanian
  { lang: Lang.SQ, name: 'Shqip' },
  // Arabic
  { lang: Lang.AR, name: 'اللغة العربية' },
  // Bosnian
  //{ lang: Lang.BS, name: 'Bosanski jezik' },
  // Bulgarian
  { lang: Lang.BG, name: 'Български език' },
  // Chinese (simplified)
  { lang: Lang.ZH_HANS, name: '简体中文' },
  // Croatian
  { lang: Lang.HR, name: 'Hrvatski' },
  // Czech
  { lang: Lang.CS, name: 'Čeština' },
  // Danish
  { lang: Lang.DA, name: 'Dansk' },
  // Dutch
  { lang: Lang.NL, name: 'Nederlands' },
  // Estonian
  { lang: Lang.ET, name: 'Eesti' },
  // Finnish
  { lang: Lang.FI, name: 'Suomi' },
  // French
  { lang: Lang.FR, name: 'Français' },
  // German
  { lang: Lang.DE, name: 'Deutsch' },
  // Greek
  { lang: Lang.EL, name: 'Ελληνικά' },
  // Hungarian
  { lang: Lang.HU, name: 'Magyar' },
  // Italian
  { lang: Lang.IT, name: 'Italiano' },
  // Japanese
  { lang: Lang.JA, name: '日本語' },
  // Korean
  { lang: Lang.KO, name: '한국어' },
  // Latvian
  { lang: Lang.LV, name: 'Latviešu' },
  // Lithuanian
  { lang: Lang.LT, name: 'Lietuvių' },
  // Norwegian
  { lang: Lang.NO, name: 'Norsk' },
  // Polish
  { lang: Lang.PL, name: 'Polski' },
  // Portuguese
  { lang: Lang.PT, name: 'Português' },
  // Romanian
  { lang: Lang.RO, name: 'Română' },
  // Russian
  { lang: Lang.RU, name: 'Русский' },
  // Serbian
  { lang: Lang.SR, name: 'Српски језик' },
  // Slovak
  { lang: Lang.SK, name: 'Slovenčina' },
  // Slovenian
  { lang: Lang.SL, name: 'Slovenski jezik' },
  // Spanish
  { lang: Lang.ES, name: 'Español' },
  // Swedish
  { lang: Lang.SV, name: 'Svenska' },
  // Turkish
  { lang: Lang.TR, name: 'Türkçe' },
  // Ukrainian
  { lang: Lang.UK, name: 'Українська' },

  // Indonesian
  { lang: Lang.ID, name: 'Bahasa Indonesia' },
  // Thai
  { lang: Lang.TH, name: 'ไทย' },
  // Vietnamese
  { lang: Lang.VI, name: 'Tiếng Việt' },
].sort((a, b) => (a.name > b.name ? 1 : -1))

/*languages.forEach(({ lang, name }, index) => {
  //import(`moment/locale/${lang.toLowerCase()}`)
  console.log(String(lang).toLowerCase())
})*/

export const LOCALE_COOKIE = '__locale'

export const saveLocale = async (localeString: string) => {
  await Preferences.set({ key: LOCALE_COOKIE, value: localeString })
}

const urlParams = new URLSearchParams(window.location.search)
if (urlParams.has('lang')) {
  const locale = String(urlParams.get('lang'))
  saveLocale(locale)
}

export const getLang = async () => {
  let lang = Lang.EN

  // Leaderboard should always be in English.
  if (window.location && window.location.pathname) {
    if (window.location.pathname.split('/')[1] === 'leaderboard') return lang
  }

  const { value: rawLocale } = await Preferences.get({ key: LOCALE_COOKIE })
  if (rawLocale) {
    const localLang = rawLocale.toUpperCase()
    if (localLang in Lang) {
      lang = localLang as Lang
    }
  }
  //else if (isNative()) {
  else {
    // Auto set language based on browser language hint.
    const { language } = navigator as any
    if (language) {
      const parts = language.split('-')
      const localLang = parts[0] === 'zh' ? 'zh_hans' : parts[0] === 'nb' ? 'no' : parts[0]
      // TODO: Norwegian
      const found = languages.find(({ lang }, index, obj) => String(lang).toLowerCase() === localLang)
      if (found) {
        lang = found.lang
      }
    }
  }
  return lang
}

const getLocale = (lang: Lang) => {
  switch (lang) {
    case Lang.EN:
      return navigator.languages && navigator.languages.length ? navigator.languages[0] : navigator.language || 'en-GB'
    case Lang.NO:
      return 'nb'
    case Lang.ZH_HANS:
      return 'zh-cn'
    default:
      return String(lang).toLowerCase()
  }
}

export const currentLang = await getLang()
export const currentLangString = String(currentLang).toLowerCase()
export const isRtl = currentLang === Lang.AR

export const currentLocale = getLocale(currentLang)
// console.log('currentLocale', currentLocale)
moment.locale(currentLocale)

if (currentLang !== Lang.EN && languages.find(({ lang }, index, obj) => lang === currentLang)) {
  try {
    const translationsObj = require(`../i18n/${currentLangString}.po.json`)
    addLocale(currentLangString, translationsObj)
    useLocale(currentLangString)

    const lang = currentLang === Lang.ZH_HANS ? 'zh-Hans' : currentLangString
    document.getElementsByTagName('html')[0].setAttribute('lang', lang)
  } catch (e) {
    console.error(`Error loading ${currentLangString}.po`)
  }
}

// For Arabic, set direction right-to-left
if (currentLang === Lang.AR) {
  document.getElementsByTagName('html')[0].setAttribute('dir', 'rtl')
}
